import {
  getStaticPathsGenerator,
  getStaticPropsGenerator,
} from '@cinch-nx/landing-feature-articles'

const path = 'articles/guides/choosing-a-car'
const resolveRelations = 'ArticleTemplate.relatedJargon'
const shouldUndashifyAndCapitalise = true

const passedBreadCrumbs = [
  { text: 'Home', url: '/' },
  { text: 'Guides', url: '/guides' },
  { text: 'Choosing a car', url: '/guides/choosing-a-car' },
]

export const getStaticProps = getStaticPropsGenerator({
  path,
  resolveRelations,
  passedBreadCrumbs,
  shouldUndashifyAndCapitalise,
})

export const getStaticPaths = getStaticPathsGenerator(path)

export { ArticlesFeature as default } from '@cinch-nx/landing-feature-articles'
